import { render, staticRenderFns } from "./enquiries.vue?vue&type=template&id=1c7823e3&"
import script from "./enquiries.vue?vue&type=script&lang=ts&"
export * from "./enquiries.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports